import React from "react";
import Header from "../Includes/Header";
import Footer from "../Includes/Footer";
import { Container, Row, Col, Card } from "react-bootstrap";

// photos list
const photos = [
  { id: 1, url: "/images/Compost_1.jpg", alt: "pic 1" },
  { id: 2, url: "/images/Compost_2.jpg", alt: "pic 2" },
  { id: 3, url: "/images/Picture1.jpg", alt: "pic 3" },
  { id: 4, url: "/images/Street.jpg", alt: "pic 4" },
  { id: 5, url: "/images/twin.jpg", alt: "pic 5" },
  { id: 6, url: "/images/What.jpg", alt: "pic 6" },
  { id: 6, url: "/containimg_16.png", alt: "pic 6" },
  { id: 6, url: "/containimg_20.jpg", alt: "pic 6" },
  
];

function PhotoGallery() {
  return (
    <>
      <Header />

      <Container className="my-5 fade-in">
        <div className="text-center mb-5">
          <h2>Photo Gallery</h2>
        </div>

        <Row className="g-4">
          {photos.map((photo) => (
            <Col key={photo.id} xs={12} sm={6} md={4} lg={3}>
              <Card className="h-100 shadow-sm border-0 photo-card">
                <Card.Img
                  variant="top"
                  src={photo.url}
                  alt={photo.alt}
                  className="gallery-image"
                />
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      <br />
      <Footer />
    </>
  );
}

export default PhotoGallery;
